var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tag',_vm._b({},'Tag',_vm.tagProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }